import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useAPI } from 'data/api';

export const useGetProjectQuery = () => {
  const { projectId } = useParams();
  const getAPI = useAPI();
  return useQuery({
    queryKey: ['getProject', projectId],
    queryFn: async () => {
      if (!projectId) throw new Error('projectId is required');
      const api = await getAPI();
      return api.projectApi.getProject({
        projectIdOrName: projectId,
        includeEntitlements: true,
      });
    },
    enabled: !!projectId,
  });
};
